import React from 'react';

const ServiceCard = ({ service, onEdit, onDelete }) => {
  const safeService = service || {};
  const {
    title = '',
    description = '',
    image = 'https://picsum.photos/seed/service-card/400/300.jpg',
    features = []
  } = safeService;

  const phoneNumber = '918053055551'; // Business phone number without +
  const defaultMessage = `Hello, I'm interested in your "${title || 'interior design'}" service. Please share details and pricing.`;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  const safeFeatures = Array.isArray(features)
    ? features.filter((feature) => typeof feature === 'string' && feature.trim().length > 0)
    : [];

  return (
    <div className="group relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
      {/* Image */}
      <div className="aspect-video overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => {
            e.currentTarget.src = 'https://picsum.photos/seed/service-card-fallback/400/300.jpg';
          }}
        />
      </div>

      {/* Action Buttons */}
      <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <button
          onClick={() => onEdit && onEdit(safeService)}
          className="p-2 rounded-full bg-white/90 hover:bg-white text-stone-600 hover:text-stone-900 transition-colors shadow-lg"
          title="Edit Service"
        >
          <span className="material-symbols-outlined text-sm">edit</span>
        </button>
        <button
          onClick={() => onDelete && onDelete(safeService)}
          className="p-2 rounded-full bg-red-500/90 hover:bg-red-500 text-white transition-colors shadow-lg"
          title="Delete Service"
        >
          <span className="material-symbols-outlined text-sm">delete</span>
        </button>
      </div>

      {/* Content */}
      <div className="p-6 sm:p-8">
        <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4" style={{color: '#3E3E3E'}}>
          {title}
        </h3>
        
        <p className="text-stone-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base line-clamp-3">
          {description}
        </p>

        {/* Features */}
        <div className="space-y-2">
          <h4 className="font-semibold text-sm sm:text-base" style={{color: '#3E3E3E'}}>
            Key Features:
          </h4>
          <ul className="space-y-1">
            {safeFeatures.slice(0, 3).map((feature, index) => (
              <li key={index} className="flex items-start gap-2 text-xs sm:text-sm" style={{color: '#7A7A7A'}}>
                <span className="material-symbols-outlined text-xs sm:text-sm mt-0.5 flex-shrink-0" style={{color: '#C8A96A'}}>
                  check_circle
                </span>
                <span>{feature}</span>
              </li>
            ))}
            {safeFeatures.length > 3 && (
              <li className="text-xs sm:text-sm font-medium" style={{color: '#C8A96A'}}>
                +{safeFeatures.length - 3} more features
              </li>
            )}
            {safeFeatures.length === 0 && (
              <li className="text-xs sm:text-sm" style={{color: '#7A7A7A'}}>
                Feature details coming soon.
              </li>
            )}
          </ul>
        </div>

        {/* CTA Button */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 w-full px-4 py-3 rounded-full font-medium transition-all duration-300 text-sm sm:text-base hover:scale-105 inline-flex items-center justify-center"
          style={{backgroundColor: '#C8A96A', color: '#FFFFFF'}}
        >
          Learn More
        </a>
      </div>
    </div>
  );
};

export default ServiceCard;
